import React, { Component, Fragment } from 'react'
import { Col, Row, Container, Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import cubeApiClient from '../BusinessObjects/cubeApiService'
import { Redirect } from 'react-router';
import LoggedContext from '../BusinessObjects/LoggedContext'
import { EsaedroChangePasswordObject } from '../Utils/EsaedroHelper';
import { themeGroup, themeCol3, themeCol9, themeFormInput } from '../Utils/EsaedroTheme';

interface IChangePasswordState{
  oldPassword: string,
  newPassword: string,
  confirmPassword: string,
  returnHome: boolean
}

export default class ChangePassword extends Component<any,IChangePasswordState> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>

    constructor(props:Readonly<any>)
    {
        super(props);
        this.state ={ oldPassword:'', newPassword:'', confirmPassword:'', returnHome: false};
    }

    handleChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        // @ts-ignore : to avoid typescript to complain 
        this.setState({
          [name]: value
        });
    }

    changePassword = () => {
      let pwdObj: EsaedroChangePasswordObject = {
        oldPassword: this.state.oldPassword,
        newPassword: this.state.newPassword,
        confirmPassword: this.state.confirmPassword
      }
      
      var token = this.context.tokenAPI;

      const service = new cubeApiClient();
      service
              .changePassword(pwdObj,token)
              .then(
                    (data: any) =>{
                                  
                                  //
                                  alert("Password cambiata correttamente")
                                  this.setState({returnHome: true})
                                  },
                    (error:any) => {
                                  //
                                  alert("Errore nel cambiare la password: " + error)
                    }
              );
    }

    returnToHome = () => {
      this.setState({returnHome: true})
    }
    
    render() {
      
      if (this.state.returnHome) {
        return (
          <Redirect to="/home"/>
        )
      }
      else return (
        <Container>
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor="oldPassword">Old Password *</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="text" name="oldPassword" required value={this.state.oldPassword} onChange={this.handleChange}/>
            </Col>
          </Row>
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor="newPassword">New Password *</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="text" name="newPassword" required value={this.state.newPassword} onChange={this.handleChange}/>
            </Col>
          </Row>
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor="confirmPassword">Confirm Password *</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="text" name="confirmPassword" required value={this.state.confirmPassword} onChange={this.handleChange}/>
            </Col>
          </Row>
          <Button color="primary" onClick={this.changePassword}>Cambia</Button>{' '}
          <Button color="secondary" onClick={this.returnToHome}>Annulla</Button>
        </Container>
      )
    }
}

